var map = {
	"./address.scss": 4163,
	"./anchor.scss": 1176,
	"./body.scss": 4425,
	"./headings.scss": 5366,
	"./html.scss": 9156,
	"./textarea.scss": 9583,
	"stylesheets/base/elements/address.scss": 4163,
	"stylesheets/base/elements/anchor.scss": 1176,
	"stylesheets/base/elements/body.scss": 4425,
	"stylesheets/base/elements/headings.scss": 5366,
	"stylesheets/base/elements/html.scss": 9156,
	"stylesheets/base/elements/textarea.scss": 9583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4127;